export enum WorkedInNorwayOption {
  All = "All",
  Yes = "Yes",
  YesWithDNumber = "YesWithDNumber",
  YesWithoutDNumber = "YesWithoutDNumber",
  No = "No"
}
